module.exports = __webpack_public_path__ + "media/images/sale_crm/inventory-8a27da300a6fc6ed241a9f225b37ce62.svg";